import React from 'react'
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import { Button, FormHelperText } from '@mui/material';
import useSubmitLock from '../../../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;

const AltaGratificacion = (props) => {
  const [monto, setMonto] = React.useState(0);

  const { lote } = props
  const { periodo } = props
  const { idempleado } = props
  const { idconcepto } = props
  const { notificacion } = props
  const { datotodoempleado } = props
  const { obtenerdatolote } = props
  const { submitting, runWithSubmitLock } = useSubmitLock()

  const handleChange = () => (event) => {
    setMonto(event.target.value);

  };


  const Addgratificacion = (monto) => runWithSubmitLock(async () => {
    const token = sessionStorage.getItem('%t')
    const montototal = parseFloat(monto)
    const resul = {
      variant: 'warning',
      msg: 'Debe ingresar el monto'

    }
    if (monto === 0 || idempleado === '') {
      notificacion(resul)

    } else {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");


      var raw = JSON.stringify({
        "idlote": lote,
        "idperiodo": periodo.idperiodo,
        "idempleado": idempleado,
        "idconcepto": `${idconcepto}`,
        "importeTotal": montototal,
        "codigoempleado": datotodoempleado.codigoempleado,
        "nombrelargo": datotodoempleado.nombrelargo,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };


      try {
        const response = await fetch(`${REACT_APP_API_URL}/pdim/percepcion`, requestOptions)
        const resultado = await response.json();


        return (notificacion(resultado), obtenerdatolote(lote), setMonto(0))
      } catch (error) {
        console.log('Algo salio mal', error);
      }
    }
  })

  return (
    <>
      <br /><br />
      <form>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard" >
          <InputLabel htmlFor="standard-adornment-amount">Monto total</InputLabel>

          <Input
            type='number'
            id="standard-adornment-amount"
            value={monto}
            onChange={handleChange('amount')}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
           <FormHelperText id="outlined-weight-helper-text">El importe a pagar es NETO</FormHelperText>
        </FormControl>
        <br /><br />
        <Button type='button' variant='contained' disabled={submitting} onClick={() => Addgratificacion(monto)}>
          Agregar
        </Button>
      </form>
    </>
  )
}

export default AltaGratificacion